import React from 'react';

export default function KirokuInputArea(props) {
    return <textarea {...props} className={`form-area ${props.className}`}/>;
}
